import FormRow from "components/form/FormRow";
import ListInput from "components/form/input/ListInput";
import SelectInput from "components/form/input/SelectInput";
import TextInput from "components/form/input/TextInput";
import { CompareSymbolSelectInput, GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import TTP from "..";

export function ParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={TTP.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Intervalo de Aderência">
                        <TextInput name="intervaloMin" label="Mínimo" type="number" />
                        <TextInput name="intervaloMax" label="Máximo" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Meta">
                        <TextInput name="meta" label="Meta (%)" type="number" />
                    </ParamFormRow>


                    <FormRow sx={{ p: 2, pl: { xs: 0, sm: 2 }, pr: { xs: 0, sm: 2 } }}>
                        <ListInput name="items" label="Pontos Amostrados">
                            <TextInput name="classificacao" label="Classificação" />
                            <CompareSymbolSelectInput name="sinalIntervaloMin" label="Sinal" />
                            <TextInput type="number" name="intervaloMin" label="Intervalo (Mín.)" />
                            <CompareSymbolSelectInput name="sinalIntervaloMax" label="Sinal" />
                            <TextInput type="number" name="intervaloMax" label="Intervalo (Máx.)" />
                            <SelectInput name="operador" label="Operador" options={['OR', 'AND']} toStringOptions={['OU', 'E']} />
                            <CompareSymbolSelectInput name="sinalIntervaloMin2" label="Sinal" />
                            <TextInput type="number" name="intervaloMin2" label="Intervalo (Mín.)" />
                            <CompareSymbolSelectInput name="sinalIntervaloMax2" label="Sinal" />
                            <TextInput type="number" name="intervaloMax2" label="Intervalo (Máx.)" />
                        </ListInput>
                    </FormRow>

                </>
            }
            bottomFields={<></>}
        />
    );
}
